var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-md-5"},[_c('StickerPayBillingData',{attrs:{"loading":_vm.isPaymentProgress ||
        _vm.startCartTransactionLoading ||
        _vm.transactionsPaymentLoading}}),_c('StickerPayEmailNotification',{attrs:{"loading":_vm.isPaymentProgress ||
        _vm.startCartTransactionLoading ||
        _vm.transactionsPaymentLoading}})],1),_c('div',{staticClass:"col-md-7 pl-md-4 pt-sm-4 pt-md-0"},[_c('StickerPayBasket',{attrs:{"loading":_vm.isPaymentProgress ||
        _vm.startCartTransactionLoading ||
        _vm.transactionsPaymentLoading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }